import {Injectable} from '@angular/core';
import {RequestService} from '../../service/request.service';
import {AuthProvider} from '../../domain/auth/auth-provider';
import {AppConfigService} from '../../../service/config/app-config.service';
import {WsDaoEventEntityType, WsRef, WsSms} from '@lifeislife/lifeislife-ws-api';
import {CachedWsResourceClient} from '../../private_util/client/cached-http-ws-Resource-client';
import {ResourceCacheService} from '../../../util/cache/resource-cache.service';

@Injectable({
  providedIn: 'root',
})
export class SmsWsClient extends CachedWsResourceClient<WsSms, WsRef<WsSms>> {

  constructor(private injectedRequestService: RequestService,
              private injectedAuthService: AuthProvider,
              private injectectedCacheService: ResourceCacheService,
              private injectedAppConfigService: AppConfigService) {
    super('/front/sms', injectedAppConfigService, injectedRequestService, injectedAuthService,
      WsDaoEventEntityType.SMS, injectectedCacheService);
  }

}
